import { createAppSelector } from 'store/hooks';

export const authActionsWrapperSelector = createAppSelector(
  [
    (state) => state.setting.isNewUserSigninProcess,
    (state) => state.setting.language
  ],
  (isNewUserSigninProcess, language) => {
    return { isNewUserSigninProcess, language };
  }
);
